import {AWAITING_FULFILLMENT} from '../../../../common/constants/Orders.js'
import {
  allSupplierOptionsSelector,
  supplierOptionTokensSelector,
} from '../../../../data/suppliers.js'
import {useDropshippingSelector} from '../../../../data/company.js'
import {useSelector} from '../../../../store.js'
import FilterPanel from './FilterPanel.js'
import {
  modalFormSelector,
  SUPPLIER_FILTER_PANEL,
  updateModalForm,
} from './orderListFilterModalFunctions.js'

export default function SupplierFilterPanel() {
  const form = useSelector(modalFormSelector)
  const supplierOptions = useSelector(allSupplierOptionsSelector)
  const useDropshipping = useSelector(useDropshippingSelector)
  const supplierOptionTokens = useSelector(supplierOptionTokensSelector)

  if (
    !(
      form.status !== AWAITING_FULFILLMENT &&
      useDropshipping &&
      supplierOptions.length > 0
    )
  ) {
    return null
  }

  return (
    <FilterPanel
      id={SUPPLIER_FILTER_PANEL}
      label="Suppliers"
      searchPlaceholder="Search for a supplier filter..."
      options={supplierOptions}
      optionTokens={supplierOptionTokens}
      selected={form.supplierFilters}
      onSelect={(option) => {
        const supplierFilters = form.supplierFilters.filter(
          (id) => id !== option.value,
        )

        if (supplierFilters.length === form.supplierFilters.length) {
          supplierFilters.push(option.value)
        }

        updateModalForm({supplierFilters})
      }}
    />
  )
}
